import { color, styled } from '@lessonup/ui-components';
import React from 'react';

/**
 * Visual-only component that renders a tag with color, label, and icon
 */
type TagWrapperProps = {
  color?: string;
  label?: string;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  withBorder?: boolean;
};

export const TagWrapper = ({ color: bgColor, label, icon, style, children, withBorder = false }: TagWrapperProps) => {
  const componentWithTag = (
    <>
      <StyledDragAndDropTag
        backgroundColor={bgColor || color.utils.focus.stroke}
        data-tag={label}
        style={style}
        label={label}
      >
        {icon && <IconWrapper style={style}>{icon}</IconWrapper>}
      </StyledDragAndDropTag>
      {children}
    </>
  );
  return withBorder ? (
    <StyledBorderWrapper borderColor={bgColor || color.utils.focus.stroke}>{componentWithTag}</StyledBorderWrapper>
  ) : (
    componentWithTag
  );
};

const StyledDragAndDropTag = styled.div<{ backgroundColor: string; label?: string }>`
  position: absolute;
  top: -25px;
  display: flex;
  left: 50%;
  transform: translateX(-50%);
  gap: 2px;
  background: ${({ backgroundColor }: { backgroundColor: string }) => backgroundColor};
  color: ${color.utils.luminocityLight.on};
  padding: ${({ label }) => `4px 4px 0px ${label ? '8px' : '4px'}`};
  border-radius: 6px 6px 0 0;
  font-size: 12px;
  font-weight: 500;

  &[data-tag]::before {
    content: attr(data-tag);
    color: ${color.utils.luminocityLight.on};
  }
`;

const StyledBorderWrapper = styled.div<{ borderColor: string }>`
  border: 2px solid ${({ borderColor }) => borderColor};
  height: 100%;
  border-radius: 8px;
`;

const IconWrapper = styled.span`
  svg {
    top: -20px;
    height: 18px;
    width: 18px;
    color: ${color.utils.luminocityLight.on};
  }
`;
